const normalizeUrl = (url: string): string => {
  return url.replace(/\/+$/, '')
}

export default function useApp() {
  const runtimeOrigin = typeof window !== 'undefined' ? window.location.origin : ''

  const appUrl = import.meta.env.VITE_APP_URL ?? runtimeOrigin
  const apiBaseUrl =
    import.meta.env.VITE_API_BASE_URL ?? `${normalizeUrl(appUrl || runtimeOrigin)}/api`

  return {
    appEnv: import.meta.env.VITE_APP_ENV,
    appUrl,
    apiBaseUrl,
    storagePrefix: '__dragon_bridge_'
  }
}
